export interface AssystProvider {
  InvestmentId: string;
  Name: string; // Adjust based on your API response
  // Add other fields as needed
}

export interface AssystDataProvider {
  DataProviderId: string;
  Name: string; // Adjust based on your API response
  // Add other fields as needed
}

export interface BulkValuationState {
  providers: AssystProvider[] | null;
  dataProvider: AssystDataProvider[] | null;
  loadingHistory: boolean;
  loadingProviders: boolean;
  loading: boolean;
  error: string | null;
  selectedProviderData: any | null;
  message: string | null; // Add message field
  valuationHistory: any | null;
  metadata: any | null;
}

export interface ApiResponse<T> {
  data: T;
}

export interface BulkValuationProps {
  selectedProviderData?: AssystProvider | null;
}

export interface DropdownOption {
  value: string;
  label: string;
}
export const initialState: BulkValuationState = {
  providers: null,
  dataProvider: null,
  loadingHistory: false,
  loadingProviders: false,
  loading: false,
  error: null,
  selectedProviderData: null,
  message: null,
  valuationHistory: null,
  metadata: null,
};
